import {useEffect, useState} from "react";
import avatarDefault from "../../../images/avatardefault.png";
import {UserViewingRecord} from "../../app/myProfileView/profileLogsView/types";
import ProfileLogsView from "../../app/myProfileView/profileLogsView/profileLogsView";
import {TitlePage} from "../../shared";
import {getCachedImageUrl} from "../../../utils/utils";
import {SquadflixLogsApi} from "../../../apis/squadflix-logs/SquadflixLogsApi";


const SquadflixLogsView = () => {

    const [error, setError] = useState<string | null>(null);
    const [usersMap, setUsersMap] = useState<Record<string, UserViewingRecord>>({});
    const [tmdbItemsMap, setTmdbItemsMap] = useState<Record<number, any>>({});

    useEffect(() => {
        SquadflixLogsApi.getSquadflixLogs({
            uid: undefined,
            startDate: undefined,
            endDate: undefined,
            tmdbId: undefined,
        }).then(res => {
            if (!res.success) {
                setError(res.error || "Unknown error");
                return;
            }
            setUsersMap(res.usersMap || []);
            setTmdbItemsMap(res.tmdbItems || {});
        }).catch(e => {
            setError(e.message);
        });
    }, []);

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div>
            <TitlePage title="Squadflix View Logs" icon="fa-solid fa-tower-observation" rightOptions={undefined}
                       titleClass={undefined} leftClass={"col-12"} rightClass={undefined} disableScroll={undefined}
                       hideSeparator={undefined} fixedHeight={undefined} className={undefined} style={undefined}/>
            {Object.values(usersMap).map(user => (
                <div key={user.uid}
                     style={{
                         border: '1px solid rgb(204 204 204 / 43%)',
                         borderRadius: "10px",
                         marginBottom: '20px',
                         padding: '10px'
                     }}>
                    <h3>
                        <img src={user.photoURL ? getCachedImageUrl(user.photoURL) : avatarDefault} onError={e => {
                            (e.target as HTMLImageElement).src = avatarDefault;
                        }} alt={user.displayName} style={{
                            width: '40px',
                            borderRadius: '20px',
                            verticalAlign: 'middle',
                            marginRight: '10px',
                            aspectRatio: '1 / 1',
                            objectFit: 'cover',
                        }}/>
                        {user.displayName}
                    </h3>
                    {user.views.length === 0 ? (
                        <p>No views recorded.</p>
                    ) : (
                        <ProfileLogsView canNavigate={true} tmdbItems={tmdbItemsMap}
                                         userViewRecord={usersMap[user.uid]}/>
                    )}
                </div>
            ))}
        </div>
    )
}

export default SquadflixLogsView;
